<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     商城管理-商品详情
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="em-product-detail">
    <div class="main-header preview-main">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
    </div>

    <div class="flex preview-main" v-loading="loading">
      <div class="preview_container">
        <preview-product
          :pics="upload_pics"
          :details="upload_details"
          :desc="detail"
          :params="productSkusAttrs"
          :good="productInfo"
          :skuInfo="skuInfo"
          :defaultSkuInfo="defaultSkuInfo"
          :shippingTemplate="shippingTemplate"
          :onlineDocument="onlineDocument"
          :resourceids="resourceids"
        />
      </div>
      <div class="props_editor">
        <div class="detail-box goods_basic">
          <div class="block_head">
            <div class="block_title">商品信息</div>
            <div class="block_category ml-sm">
              {{ cat.cat_name }}
            </div>
            <el-button class="ml" type="text" @click="categoryShow = true">修改品类</el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="input-title">商品标题</div>
              <el-input v-model="productInfo.title" class="product-input" :minlength="1" :maxlength="60" show-word-limit placeholder="填写商品名称与关键字" />
              <div v-show="!titleValidateFlag" class="tip text-danger mt-xs font-sm">商品标题应为1-60个字符</div>
            </el-col>
            <el-col :span="12">
              <div class="input-title">商品描述<span class="text-muted ml-xs">(选填)</span></div>
              <el-input v-model="productInfo.sub_title" class="product-input" maxlength="50" show-word-limit placeholder="填写商品描述" />
            </el-col>
          </el-row>
          <div class="input-title mt-lg">商品图片</div>
          <f-image-card-uploader class="mt" :files.sync="upload_pics" :multiple="true" :fromChild.sync="fromChild" :isUpload.sync="isUpload" :limit="9" aimPath="eishop/" @change="imageUpload" />
          <div class="tip text-muted mt">最多上传9个素材，单张图片需限制在2M以内</div>
          <div v-show="!pictureValidateFlag" class="tip text-danger mt-xs font-sm">商品图片数量应为1-9</div>
        </div>

        <div class="detail-box goods_params">
          <div class="block_head">
            <div class="block_title">商品规格<span class="text-muted ml-sm text-lighter font-sm">(选填) </span></div>
          </div>
          <template v-if="productSkusAttrs.length">
            <div v-for="(item, index) in productSkusAttrs" :key="index" class="goods-attr-item">
              <div class="goods-item-row">
                <div class="goods-item-row-left">
                  <div class="goods-item-title">规格{{ index + 1}}</div>
                  <el-input v-model="item.attr_key" class="ml-lg mr" maxlength="230" placeholder="填写规格名称" @change="attrkeyChange(index)" />

                </div>
                <div class="goods-item-row-right">
                  <el-button type="text" class="del-btn" @click="deleteParam(index)">删除规格</el-button>
                </div>
              </div>
              <div v-for="(param, param_index) in item.attr_info" :key="param_index" class="goods-content-row" @click="handleRowClick(param.sort_id)">
                <el-input v-model="param.attr_value" class="mr" maxlength="40" placeholder="请输入" />

                <div class="icon-box">
                  <div class="iconItem" role="button" @click="addNewline(index)"><i class="el-icon-circle-plus-outline"></i></div>
                  <div class="iconItem" :style="(item.attr_info.length === 1 || param_index === 0) ? 'pointer-events: none;color:#ddd' : 'cursor:pointer' " @click="upLine(index, param_index)"><i class="el-icon-arrow-up"></i></div>
                  <div class="iconItem" :style="param_index === item.attr_info.length - 1 ? 'pointer-events: none;color:#ddd' : 'cursor:pointer'" @click="downLine(index, param_index)"><i class="el-icon-arrow-down"></i></div>
                  <div class="iconItem" :style="item.attr_info.length > 1 ? 'cursor:pointer' : 'pointer-events: none;color:#ddd'" @click="deleteLine(index, param_index)"><i class="el-icon-delete"></i></div>
                </div>
              </div>
            </div>
          </template>
          <div v-if="productSkusAttrs.length < 2" class="mt flex align-items-center add-param text-primary">
            <i class="el-icon-circle-plus-outline" @click="addParam()"></i>
            <span class="ml-xs" @click="addParam()">创建新规格</span>
          </div>
        </div>

        <div class="detail-box goods_price">
          <div class="block_head">
            <div class="block_title">商品售价</div>
          </div>
          <template v-if="productSkusAttrs.length">
            <div class="conent-list">
              <div class="conent-title pt pb">
                <el-row :gutter="20" style="width: 100%;">
                  <template v-if="isGodid1">
                    <el-col :span="8">售卖价</el-col>
                    <el-col :span="8">市场价<span class="text-muted ml-xs">(选填)</span></el-col>
                    <el-col :span="8">库存</el-col>
                  </template>
                  <template v-else>
                    <el-col :span="12">售卖价</el-col>
                    <el-col :span="12">市场价<span class="text-muted ml-xs">(选填)</span></el-col>
                  </template>
                </el-row>
              </div>
              <div class="listBox">
                <div v-for="(item, index) in skuInfo" :key="index" class="listItem mb">
                  <div class="flex mb align-items-center">
                    <template v-if="item.spec.length">
                      <div v-for="(attr, i) in item.spec" :key="i" class="mr-xs">
                        {{ attr.attr_value }}
                      </div>
                    </template>
                  </div>
                  <el-row :gutter="20" style="width: 100%;">
                    <template v-if="isGodid1">
                      <el-col :span="8" class="flex align-items-center">
                        <div class="money-icon">￥</div>
                        <el-input-number placeholder="输入售卖价格" :controls="false" :min="0.01" :precision="2" v-model="item.sale_price" />
                        <i role="button" class="ml-sm iconfont icon-tag text-muted" :class="{ 'text-primary': item.advanced_prices && item.advanced_prices.length }" @click="showTierPricingSetting(item, index)"></i>
                      </el-col>
                      <el-col :span="7" :offset="1" class="flex align-items-center">
                        <div class="money-icon">￥</div>
                        <el-input-number placeholder="输入市场价格" :controls="false" :min="0.01" :precision="2" v-model="item.market_price" />
                      </el-col>
                      <el-col :span="7" :offset="1" class="flex align-items-center">
                        <div class="money-icon"><i class="el-icon-coin"></i></div>
                        <el-input-number placeholder="输入库存" :controls="false" :min="0" :precision="0" v-model="item.stock_num" />
                      </el-col>
                    </template>
                    <template v-else>
                      <el-col :span="12" class="flex align-items-center">
                        <div class="money-icon">￥</div>
                        <el-input-number placeholder="输入售卖价格" :controls="false" :min="0.01" :precision="2" v-model="item.sale_price" />
                        <i role="button" class="ml-sm iconfont icon-tag text-muted" :class="{ 'text-primary': item.advanced_prices && item.advanced_prices.length }" @click="showTierPricingSetting(item, index)"></i>
                      </el-col>
                      <el-col :span="12" class="flex align-items-center">
                        <div class="money-icon">￥</div>
                        <el-input-number placeholder="输入市场价格" :controls="false" :min="0.01" :precision="2" v-model="item.market_price" />
                      </el-col>
                    </template>

                  </el-row>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="conent-list">
              <div class="conent-title pt pb">
                <el-row :gutter="20" style="width: 100%;">
                  <template v-if="isGodid1">
                    <el-col :span="8">售卖价</el-col>
                    <el-col :span="8">市场价<span class="text-muted ml-xs">(选填)</span></el-col>
                    <el-col :span="8">库存</el-col>
                  </template>
                  <template v-else>
                    <el-col :span="12">售卖价</el-col>
                    <el-col :span="12">市场价<span class="text-muted ml-xs">(选填)</span></el-col>
                  </template>
                </el-row>
              </div>
              <div class="listBox pb">
                <el-row :gutter="20" style="width: 100%;">
                  <template v-if="isGodid1">
                    <el-col :span="8" class="flex align-items-center">
                      <div class="money-icon">￥</div>
                      <el-input-number placeholder="输入售卖价格" :controls="false" :min="0.01" :precision="2" v-model="defaultSkuInfo.sale_price" />
                      <i role="button" class="ml-sm iconfont icon-tag text-muted" :class="{ 'text-primary': defaultSkuInfo.advanced_prices.length }" @click="showTierPricingSetting(defaultSkuInfo)"></i>
                    </el-col>
                    <el-col :span="7" :offset="1" class="flex align-items-center">
                      <div class="money-icon">￥</div>
                      <el-input-number placeholder="输入市场价格" :controls="false" :min="0.01" :precision="2" v-model="defaultSkuInfo.market_price">
                      </el-input-number>
                    </el-col>
                    <el-col :span="7" :offset="1" class="flex align-items-center">
                      <div class="money-icon"><i class="el-icon-coin"></i></div>
                      <el-input-number placeholder="输入库存" :controls="false" :min="0" :precision="0" v-model="defaultSkuInfo.stock_num">
                      </el-input-number>
                    </el-col>
                  </template>
                  <template v-else>
                    <el-col :span="12" class="flex align-items-center">
                      <div class="money-icon">￥</div>
                      <el-input-number placeholder="输入售卖价格" :controls="false" :min="0.01" :precision="2" v-model="defaultSkuInfo.sale_price" />
                      <i role="button" class="ml-sm iconfont icon-tag text-muted" :class="{ 'text-primary': defaultSkuInfo.advanced_prices.length }" @click="showTierPricingSetting(defaultSkuInfo)"></i>
                    </el-col>
                    <el-col :span="12" class="flex align-items-center">
                      <div class="money-icon">￥</div>
                      <el-input-number placeholder="输入市场价格" :controls="false" :min="0.01" :precision="2" v-model="defaultSkuInfo.market_price" />
                    </el-col>
                  </template>
                </el-row>
              </div>
            </div>
          </template>
        </div>

        <div class="detail-box goods_detail">
          <div class="block_head">
            <div class="block_title">商品资料<span class="text-muted ml-sm text-lighter font-sm">(选填) </span></div>
          </div>
          <el-select v-model="resourceids" multiple style="width: 100%;">
            <el-option
              v-for="item in onlineDocument"
              :key="item.resourceid"
              :label="item.title"
              :value="item.resourceid"
            />
          </el-select>
        </div>

        <div class="detail-box goods_detail">
          <div class="block_head">
            <div class="block_title">商品详情<span class="text-muted ml-sm text-lighter font-sm">(选填) </span></div>
          </div>
          <el-input v-model="detail.desc" type="textarea" :rows="6" maxlength="2000" show-word-limit placeholder="商品详细介绍，限2000字符" />
          <f-image-card-uploader class="mt" :files.sync="upload_details" :multiple="true" :fromChild.sync="fromChild" :isUpload.sync="isUpload" :limit="20" aimPath="eishop/" @change="detailUpload" />
          <div class="tip text-muted mt">最多上传20个素材，单张图片需限制在2M以内</div>
        </div>

        <div class="detail-box goods_detail">
          <div class="block_head">
            <div class="block_title">物流配送</div>
          </div>
          <el-select v-model="productInfo.templateid" class="select mb-md" @change="handleTemplateChange">
            <el-option
              v-for="item in shipping_template_list"
              :key="item.templateid"
              :label="item.name"
              :value="item.templateid"
            />
          </el-select>
          <div v-if="productInfo.templateid" class="goods-attr-item shipping">
            <el-form label-width="90px" label-position="left">
              <el-form-item label="发货时效">
                {{ ship }}
              </el-form-item>
              <el-form-item label="默认运费">
                {{ shippingTemplate.default_freight }}
              </el-form-item>
              <el-form-item v-if="shippingTemplate.calc_freight" label="指定运费">
                {{ shippingTemplate.calc_freight }}
              </el-form-item>
              <el-form-item label="不配送地区">
                {{ shippingTemplate.no_send_area_freight }}
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div v-if="isGodid1" class="detail-box goods_detail">
          <div class="block_head">
            <div class="block_title">购买设置</div>
          </div>
          <el-form label-width="90px" label-position="left">
            <el-form-item class="limit" label="限购">
              <el-switch v-model="productInfo.is_limit" active-text="开启限购" :active-value="1" :inactive-value="0" />
              <div v-if="productInfo.is_limit" class="flex align-items-center mt-lg">
                每人
                <el-select v-model="productInfo.limit_type" class="limit-type-select ml-sm mr-sm">
                  <el-option v-for="item in limitTypeList" :key="item.id" :label="item.value" :value="item.id" />
                </el-select>
                限购
                <f-number-unit v-model="productInfo.limit_num" unit="件" :min="1" :step="1" step-strictly />
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div class="viod_placeholder"></div>

        <div class="fix_bottom flex align-items-center justify-content-space-between">
          <div class="radio-box flex align-items-center" :class="{'active': productInfo.showcase_enable}" @click="radioChange">
            <div class="radio-btn">
              <i class="el-icon-check"></i>
            </div>
            <span class="ml-xs">加入橱窗</span>
          </div>
          <div class="button_content flex align-items-center">
            <div class="ft-btn normal-btn" v-if="productInfo.productid && edit_status != 2" @click="delProduct">删除</div>

            <div class="ft-btn normal-btn" v-if="status == 5 && edit_status != 2" @click="offShelf">下架</div>
            <div class="ft-btn primay-btn" v-if="edit_status != 2 && status !== 13" @click="saveProduct(2)">上架</div>
            <div class="ft-btn primay-btn" v-if="edit_status == 2 && status !== 13" @click="resetReview">撤销审核</div>
          </div>
        </div>

      </div>
    </div>

    <product-category v-if="categoryShow" :arr="[cat.first_cat_id,cat.second_cat_id,cat.third_cat_id]" :show.sync="categoryShow" @change="changeCat" />

    <tier-pricing-setting v-if="settingShow" :show.sync="settingShow" :skuid="activeSkuid" :index="activeSkuIndex" :activeSkuInfo="activeSkuInfo" :advanced_prices="activePrices" @submit="submit" />
  </div>
</template>

<script>
import { cartesian } from "@/utils/common";
import {
  getCategoryDetailApi,
  postProductApi,
  getProductDetailApi,
  putOffShelfApi,
  delProductApi,
  resetProductReviewApi,
  getShippingTemplateListApi
} from "@/api/ei/eiMallApi";
import { getGodOnlineDocumentApi } from "@/api/fam/famGodApi";
import Vue from "vue";

export default {
  name: "EmProductDetail",
  components: {
    PreviewProduct: () => import("./components/PreviewProduct"),
    FImageCardUploader: () => import("@/components/FImageCardUploader"),
    ProductCategory: () => import("./components/ProductCategory"),
    TierPricingSetting: () => import("./components/TierPricingSetting")
  },

  data() {
    return {
      settingShow: false,
      activeSkuInfo: {
        price: undefined,
        title: undefined
      },
      activeSkuid: undefined,
      activeSkuIndex: undefined,
      activePrices: [],
      action_url: '',
      categoryShow: false,
      loading: false,
      edit_status: null,
      status: null,
      detail: {},
      upload_pics: [],
      upload_details: [],
      productSkusAttrs: [],
      productInfo: {
        title: "",
        templateid: 0,
        delivery_time_type: undefined,
        catid: this.$route.query.cat_id
          ? parseInt(this.$route.query.cat_id)
          : null,
        productid: this.$route.query.productid
          ? parseInt(this.$route.query.productid)
          : null,
        showcase_enable: this.$route.query.cat_id ? 1 : 0,
        is_limit: 0, // 是否开启限购
        limit_type: 3, // 限购类型
        limit_num: 1, // 限购数量
      },
      defaultSkuInfo: {
        sale_price: undefined,
        market_price: undefined,
        skuid: null,
        advanced_prices: [],
        stock_num: undefined,
      },
      cat: {},
      good: {},
      skuInfo: [],
      ids: [],
      titleValidateFlag: false,
      pictureValidateFlag: false,
      selected_sort_id: null, // 正在被操作的规格列
      fromChild: false,
      isUpload: 0,
      shipping_template_list: [{ templateid: 0, name: '包邮'}],
      shippingTemplate: {},
      limitTypeList: [
        {
          id: 1,
          value: '每日'
        },
        {
          id: 2,
          value: '每月'
        },
        {
          id: 3,
          value: '每年'
        },
        {
          id: 4,
          value: '总计'
        }
      ],
      onlineDocument: [],
      resourceids: [],
      resources: [],
    };
  },

  computed: {
    deliveryTimeTypeObj() {
      return this.$store.getters.deliveryTimeTypeObj;
    },
    ship() {
      let ship = ''
      if (this.shippingTemplate.templateid && this.productInfo.templateid) {
        ship = this.deliveryTimeTypeObj[this.shippingTemplate.delivery_time_type].value
      }

      return ship
    },
    isGodid1() {
      return this.$store.state.godStore.godid === 1;
    }
  },

  watch: {
    productSkusAttrs: {
      deep: true,
      handler: function(val, oldVal) {
        this.freshSku();
      }
    },
    productInfo: {
      deep: true,
      handler: function(val, oldVal) {
        if (
          this.productInfo.title &&
          this.productInfo.title.length >= 1 &&
          this.productInfo.title.length <= 60
        ) {
          this.titleValidateFlag = true;
        } else {
          this.titleValidateFlag = false;
        }
      }
    },
    upload_pics() {
      if (this.upload_pics.length >= 1 && this.upload_pics.length <= 9) {
        this.pictureValidateFlag = true;
      } else {
        this.pictureValidateFlag = false;
      }
    }
  },

  created: function() {
    this.fetchData();
  },

  methods: {
    // 显示等级设置设置弹窗
    showTierPricingSetting(item, index) {
      this.activeSkuInfo = {
        price: item.sale_price,
        title: item.spec.length ? item.spec.map(attr => attr.attr_value).join(' ') : '默认'
      }
      this.activeSkuid = item.skuid
      this.activeSkuIndex = index
      this.activePrices = item.advanced_prices
      this.settingShow = true
    },

    // 提交等级设置
    submit(e) {
      if (this.skuInfo.length) {
        this.skuInfo.forEach((item, index) => {
          if (e.skuid && item.skuid === e.skuid) {
            item.advanced_prices = e.advanced_prices
          } else if (!e.skuid && index === e.index) {
            item.advanced_prices = e.advanced_prices
          }
        })
      } else {
        this.defaultSkuInfo.advanced_prices = e.advanced_prices
      }
      this.$message.success('操作成功')
      this.settingShow = false
    },

    getOnlineDocument() {
      getGodOnlineDocumentApi().then(res => {
        if (!res.errno) {
          this.onlineDocument = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 拉取数据
    async fetchData() {
      this.getOnlineDocument()
      const res = await getShippingTemplateListApi()
      if (!res.errno) {
        this.shipping_template_list = [...this.shipping_template_list, ...res.data.list]
      } else {
        this.$message.error(res.message)
      }
      if (this.productInfo.catid) {
        getCategoryDetailApi({ cat_id: this.productInfo.catid })
          .then(res => {
            if (!res.errno) {
              this.cat = Object.assign({}, res.data);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
      }
      if (this.productInfo.productid) {
        this.loading = true;
        getProductDetailApi({ productid: this.productInfo.productid }).then(
          res => {
            this.loading = false;
            if (!res.errno) {
              this.edit_status = res.data.edit_status;
              this.status = res.data.status;
              this.productInfo = {...res.data.productInfo, templateid: res.data.productInfo.templateid || 0};
              this.resourceids = res.data.resources.map(item => item.resourceid);
              this.resources = res.data.resources;
              if (this.productInfo.templateid) {
                this.shippingTemplate = this.shipping_template_list.find(item => item.templateid === this.productInfo.templateid) || {}
                this.productInfo.templateid = this.shippingTemplate.templateid || 0
              }
              this.upload_pics = res.data.productInfo.head_img;
              this.upload_details = res.data.detail.detail_img;
              this.detail = res.data.detail;

              if (res.data.productSkuInfo.length) {
                this.skuInfo = res.data.skuInfo;
                this.productSkusAttrs = res.data.productSkuInfo;
              } else {
                this.defaultSkuInfo = Object.assign({}, this.defaultSkuInfo, res.data.skuInfo[0])
              }
            } else {
              this.$message.error(res.message);
            }
          }
        );
      }

    },

    // 生成sku 写入商品规格生成商品售价列
    freshSku() {
      let res = [],
        arr = [];
      const reduceList = this.productSkusAttrs.map(v => v.attr_info);
      arr = cartesian(reduceList);
      for (let attr_item of arr) {
        // 对商品售价进行处理
        let attr = {};
        if (reduceList.length < 2) {
          // 单规格
          let obj = {};
          if (this.skuInfo.length) {
            for (let i = 0; i < this.skuInfo.length; i++) {
              if (
                this.skuInfo[i].sort_arr.indexOf(Number(attr_item.sort_id)) > -1
              ) {
                obj = this.skuInfo[i];
              }
            }
          }
          attr = {
            spec: Array.of(attr_item),
            sale_price: obj ? obj.sale_price : null,
            market_price: obj ? obj.market_price : null,
            skuid: obj ? obj.skuid : null,
            sort_arr: [attr_item.sort_id],
            advanced_prices: obj ? obj.advanced_prices : [],
            stock_num: obj ? obj.stock_num : null,
          };
        } else {
          // 多规格
          let tmp = [];
          let obj = {};
          for (let item of attr_item) {
            tmp.push(Number(item.sort_id));
          }
          if (this.skuInfo.length) {
            for (let j = 0; j < this.skuInfo.length; j++) {
              if (tmp.every(val => this.skuInfo[j].sort_arr.includes(val))) {
                obj = this.skuInfo[j];
              }
            }
          }
          attr = {
            spec: attr_item,
            sale_price: obj ? obj.sale_price : null,
            market_price: obj ? obj.market_price : null,
            skuid: obj ? obj.skuid : null,
            sort_arr: tmp,
            advanced_prices: obj ? obj.advanced_prices : [],
            stock_num: obj ? obj.stock_num : null,
          };
        }
        res.push(attr);
      }
      this.skuInfo = res;
    },

    // 配图事件触发
    allowUploadPic(i) {
      this.productSkusAttrs[i].is_show = 1;
      for (let j = 0; j < this.productSkusAttrs.length; j++) {
        if (j != i) {
          this.productSkusAttrs[j].is_show = 0;
        } else {
          for (let k = 0; k < this.productSkusAttrs[j].attr_info.length; k++) {
            Vue.set(this.productSkusAttrs[j].attr_info[k], "attr_img", "");
          }
        }
      }
    },

    // 修改分类
    changeCat(catid) {
      this.productInfo.catid = catid;
      this.fetchData();
    },

    /** 规格图片上传方法集合 */
    changeImgUrl(url) {
      for (let item of this.productSkusAttrs) {
        for (let i = 0; i < item.attr_info.length; i++) {
          if (item.attr_info[i].sort_id === this.selected_sort_id) {
            item.attr_info[i].attr_img = url;
          }
        }
      }
    },
    beforeUpload(file) {
      const formatArr = ["image/jpeg", "image/png"];
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error("上传图片格式只支持 jpg、 png！");
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 2M！");
        return false;
      }
      return true;
    },
    handleExceed() {
      this.$message.error(`最多上传 1 张图片！`);
    },
    handleRemove(file, fileList) {
      this.changeImgUrl("");
    },
    handleRowClick(id) {
      this.selected_sort_id = id;
    },
    handleSkuImgUploadSuccess(response, file, fileList) {
      if (!response.errno) {
        let url = response.data.url;
        this.changeImgUrl(url);
      }
    },
    /** 规格图片上传方法集合 */

    // 图片上传
    imageUpload(arr) {
      this.upload_pics = arr;
    },

    // 商品详情图片上传
    detailUpload(arr) {
      this.upload_details = arr;
    },

    // 规格名称修改
    attrkeyChange(index) {
      const arr = this.productSkusAttrs[index].attr_info;
      for (const v of arr) {
        v.attr_key = this.productSkusAttrs[index].attr_key;
      }
    },

    // 生成一个新的id
    createNewId() {
      let next_id = 1,
        ids = [];
      if (this.productSkusAttrs.length) {
        // 商品规格数组不为空
        for (let i = 0; i < this.productSkusAttrs.length; i++) {
          let item = this.productSkusAttrs[i];
          for (let j = 0; j < item.attr_info.length; j++) {
            let _item = item.attr_info[j];
            ids.push(_item.sort_id);
          }
        }
        next_id = Math.max(...ids) + 1;
      }
      return next_id;
    },

    // 新增规格（上限两个）
    addParam() {
      let next_id = this.createNewId();
      this.productSkusAttrs.push({
        attr_key: "",
        is_show: 0,
        attr_info: [
          {
            sort_id: next_id,
            attr_img: "",
            attr_key: "",
            attr_value: ""
          }
        ]
      });
    },

    // 新增规格子属性
    addNewline(index) {
      let next_id = this.createNewId();
      this.productSkusAttrs[index].attr_info.push({
        sort_id: next_id,
        attr_img: "",
        attr_key: this.productSkusAttrs[index].attr_key,
        attr_value: ""
      });
    },

    // 删除规格
    deleteParam(index) {
      this.productSkusAttrs.splice(index, 1);
    },

    // 规格子属性上移
    upLine(index, param_index) {
      if (param_index === 0) return;
      const temp = this.productSkusAttrs[index].attr_info[param_index];
      this.productSkusAttrs[index].attr_info.splice(param_index, 1);
      this.productSkusAttrs[index].attr_info.splice(param_index - 1, 0, temp);
    },

    // 规格子属性下移
    downLine(index, param_index) {
      if (param_index === this.productSkusAttrs[index].attr_info.length - 1)
        return;
      const temp = this.productSkusAttrs[index].attr_info[param_index];
      this.productSkusAttrs[index].attr_info.splice(param_index, 1);
      this.productSkusAttrs[index].attr_info.splice(param_index + 1, 0, temp);
    },

    // 删除规格子属性
    deleteLine(index, param_index) {
      this.productSkusAttrs[index].attr_info.splice(param_index, 1);
    },

    // 删除商品
    delProduct() {
      this.$confirm("请确认是否删除该商品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          delProductApi({ productids: [this.productInfo.productid] }).then(
            res => {
              this.loading = false;
              if (!res.errno) {
                this.$message.success("删除商品成功！");
                this.$router.go(-1);
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {});
    },

    // 撤销审核
    resetReview() {
      this.$confirm("请确认是否撤销正在审核的商品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          resetProductReviewApi({ productid: this.productInfo.productid }).then(
            res => {
              this.loading = false;
              if (!res.errno) {
                this.$message.success("撤销成功！");
                this.$router.go(-1);
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {});
    },

    // 下架商品
    offShelf() {
      this.$confirm("请确认是否下架该商品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          putOffShelfApi({ productid: this.productInfo.productid }).then(
            res => {
              this.loading = false;
              if (!res.errno) {
                this.$message.success("下架商品成功！");
                this.$router.go(-1);
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {});
    },

    // 校验skuInfo
    checkSkuInfo() {
      for (let i of this.productSkusAttrs) {
        if (!i.attr_key) {
          this.$message.error("商品规格名称不能为空！");
          return false;
        }
        for (let j of i.attr_info) {
          if (!j.attr_value) {
            this.$message.error("商品子规格项不能为空！");
            return false;
          }
        }
      }
      for (let item of this.skuInfo) {
        if (!item.market_price || !item.sale_price) {
          if (!item.sale_price) {
            this.$message.error("商品售卖价不能为空！");
            return false;
          }
        } else {
          if (Number(item.sale_price) > Number(item.market_price)) {
            this.$message.error("商品售卖价不能大于市场价！");
            return false;
          }
        }
        // if (this.isGodid1 && !item.stock_num) {
        //     this.$message.error("商品库存不能为空或0！");
        //     return false;
        // }
      }
      return true;
    },

    // 校验defaultSkuInfo
    checkDefaultSkuInfo() {
      if (this.defaultSkuInfo.sale_price) {
        if (this.defaultSkuInfo.market_price) {
          if (Number(this.defaultSkuInfo.sale_price) > Number(this.defaultSkuInfo.market_price)) {
            this.$message.error("商品售卖价不能大于市场价！");
            return false;
          }
        }
      } else {
        this.$message.error("商品售卖价不能为空！");
        return false;
      }
      return true;
    },

    // 提交表单
    saveProduct(type) {
      // 进行表单校验
      if (!this.titleValidateFlag) {
        this.$message.error("请填写商品标题！");
        return;
      }
      if (!this.pictureValidateFlag) {
        this.$message.error("请上传商品图片！");
        return;
      }
      let priceValidateFlag = this.skuInfo.length
        ? this.checkSkuInfo()
        : this.checkDefaultSkuInfo();
      if (
        this.titleValidateFlag &&
        this.pictureValidateFlag &&
        priceValidateFlag
      ) {
        this.productInfo = Object.assign(this.productInfo, {
          head_img: this.upload_pics
        });
        this.detail = Object.assign(this.detail, {
          detail_img: this.upload_details
        });
        let currentSkuInfo = this.skuInfo.length ? this.skuInfo : [this.defaultSkuInfo];
        if (!this.isGodid1) {
          currentSkuInfo = currentSkuInfo.map(item => {
            if (item.stock_num) {
              delete item.stock_num;
            }
            return item;
          });
        }
        let currentProductInfo = {...this.productInfo, templateid: this.productInfo.templateid || 0};
        if (!this.isGodid1) {
          delete currentProductInfo.is_limit;
          delete currentProductInfo.limit_type;
          delete currentProductInfo.limit_num;
        }
        const temp = {
          productid: this.productInfo.productid
            ? this.productInfo.productid
            : "",
          productInfo: currentProductInfo,
          productSkusAttrs: this.productSkusAttrs,
          skuInfo: currentSkuInfo,
          detail: this.detail,
          type: type,
          resourceids: this.resourceids
        };
        this.loading = true;

        if (this.fromChild) {
          postProductApi({ product: temp })
            .then(res => {
              this.loading = false;
              if (!res.errno) {
                this.$message.success(res.message);
                this.$router.push("/em/product");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {});
        } else if (this.isUpload == 0) {
          postProductApi({ product: temp })
            .then(res => {
              this.loading = false;
              if (!res.errno) {
                this.$message.success(res.message);
                this.$router.push("/em/product");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {});
        } else {
          this.$message.error("请等待上传完成！");
          this.loading = false;
        }
      }
    },

    handleTemplateChange(templateid) {
      this.shippingTemplate = this.shipping_template_list.find(item => item.templateid === templateid)
    },

    radioChange() {
      this.productInfo.showcase_enable = this.productInfo.showcase_enable ? 0 : 1;
    }
  }
};
</script>

<style lang="scss" slot-scoped>
.em-product-detail {
  .preview-main {
    width: 1272px;
    padding: 0 24px;
    box-sizing: border-box;
    margin: 0 auto;
    .preview_container {
      position: relative;
      width: 375px;
      flex-shrink: 0;
    }
    .product-input {
      .el-input__inner {
        padding-right: 45px;
      }
    }
    .props_editor {
      margin-left: 24px;
      flex-grow: 1;
      .detail-box {
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 24px;
        padding: 32px;
        .block_head {
          padding-bottom: 32px;
          display: flex;
          align-items: center;
          .block_title {
            font-size: 20px;
            font-weight: bold;
            line-height: 28px;
          }
          .block_category {
            font-size: 16px;
            cursor: pointer;
          }
        }
        .input-title {
          padding-bottom: 8px;
          font-size: 16px;
          display: flex;
        }
        .add-param {
          cursor: pointer;
          line-height: 1.6;
        }
        .goods-attr-item {
          background-color: #f9f9f9;
          border-radius: 8px;
          padding: 24px;
          margin-bottom: 24px;
          .goods-item-row {
            display: flex;
            justify-content: space-between;
            .goods-item-row-left {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              height: 40px;
              .goods-item-title {
                width: 42px;
                font-size: 16px;
              }
              .el-input {
                width: 120px;
              }
            }
            .goods-item-row-right {
              .del-btn {
                color: #576b95;
              }
            }
          }
          .goods-content-row {
            margin-top: 12px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-left: 72px;
            .el-input {
              width: 280px;
            }
            .icon-box {
              background: rgba(255, 255, 255, 0.9);
              border-radius: 4px;
              display: flex;
              .iconItem {
                background: #fff;
                width: 30px;
                height: 30px;
                margin: 3px;
                border-radius: 4px;
                text-align: center;
                &:hover {
                  background: rgba(0, 0, 0, 0.03);
                }
                i {
                  width: 20px;
                  height: 20px;
                  font-size: 16px;
                  line-height: 20px;
                  margin: 5px;
                }
              }
            }
            .skuImg {
              width: 40px;
              height: 40px;
              .el-upload-list--picture-card .el-upload-list__item {
                width: 40px;
                height: 40px;
                .el-upload-list__item-status-label {
                  background: #07c160;
                }
              }
              .el-upload {
                position: relative;
                width: 40px;
                height: 40px;
                line-height: 38px;
                padding-top: 5px;
                .num-tips {
                  position: absolute;
                  bottom: 4px;
                  right: 4px;
                  line-height: 1;
                  color: #ccc;
                  font-size: 13px;
                }
              }
              .is-limit .el-upload {
                display: none;
              }
            }
          }

          .el-form-item {
            .el-form-item__label {
              color: #909399;
            }
          }
        }

        .shipping {
          margin-bottom: 0;
        }

        .el-form-item {
          margin-bottom: 20px;

          &:last-child {
            margin-bottom: 0;
          }

          &.limit {
            .el-form-item__label {
              color: #303133;
            }

            .el-form-item__content {
              color: #303133;
            }
          }

          .limit-type-select {
            width: 100px;
          }
        }
        .conent-list {
          .listBox {
            border-bottom: 1px solid #f6f7f8;
            border-top: 1px solid #f6f7f8;
            padding-top: 25px;
            .money-icon {
              width: 60px;
              height: 36px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #97999d;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              border: 1px solid #dcdfe6;
              border-right: none;
              background-color: #f6f7f8;
            }
            .el-input-number {
              .el-input {
                .el-input__inner {
                  border-top-left-radius: 0;
                  border-bottom-left-radius: 0;
                }
              }
            }
          }
        }
      }
      .viod_placeholder {
        width: 100%;
        height: 80px;
      }
      .fix_bottom {
        width: 825px;
        bottom: 0;
        position: fixed;
        height: 80px;
        z-index: 4;
        border-top: 0.5px solid rgba(0, 0, 0, 0.05);
        background-color: #fff;
        padding: 0 32px;
        border-radius: 8px 8px 0 0;

        .radio-box {
          cursor: pointer;
          user-select: none;

          &.active {
            .radio-btn {
              border-color: #07c160;
              background-color: #07c160;
              i {
                display: block;
              }
            }
          }

          .radio-btn {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 1px solid #dcdfe6;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i {
              color: #fff;
              font-size: 14px;
              display: none;
            }
          }
        }

        .ft-btn {
          width: auto;
          min-width: 116px;
          font-size: 16px;
          height: 40px;
          line-height: 40px;
          padding: 0 0.75em;
          border-radius: 8px;
          font-weight: 700;
          text-align: center;
          cursor: pointer;
        }
        .normal-btn {
          color: #fa5151;
          background-color: #eee;
          margin-left: 8px;
          &:hover {
            background-color: rgba($color: #eee, $alpha: 0.8);
          }
        }
        .primay-btn {
          color: #fff;
          background-color: #fa5151;
          margin-left: 8px;
          &:hover {
            background-color: rgba($color: #fa5151, $alpha: 0.8);
          }
        }
      }
    }
  }
  .icon-tag {
    font-size: 20px;
    line-height: 36px;
    transform: rotate(-90deg);
  }

}

</style>
